/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name  MetricData
 * @description
 *     An item of a MetricDataCollection, a collection created from a metrics API.
 * @typedef {Object} MetricData
 */
angular.module('aviApp').factory('MetricData', ['Item',
Item => {
    class MetricData extends Item {
        /** @override */
        getIdFromData_(data) {
            return data && data.id || '';
        }
    }

    MetricData.prototype.objectName = 'metricdata';

    return MetricData;
}]);
